import React from 'react';
import {observer, inject} from 'mobx-react';
import classNames from 'classnames';
@inject('workshopDetails')
@observer
export default class NavigationWorkshop extends React.Component {


  handleClick = () => {
    this.props.workshopDetails.changeOpenedType({type: 'workshop', index: -1})
  };

  render(){
    let active = this.props.workshopDetails.openedType.type === 'workshop';
    return(
      <li className={classNames('workshop-card-module-item', {active: active })}
          onClick={this.handleClick}
      style={{display: this.props.display.display}}>
      <span className="workshop-card-module-number"><i className="ic-flag-ico" style={{ fontSize: 10}}/></span>
      <span className="workshop-card-module-caption">{this.props.workshopDetails.workshop.title}</span>
    </li>)
  }
}



// WEBPACK FOOTER //
// ./src/components/providers/online_workshop_details/NavigationWorkshop.jsx